<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <h1 class="sr-only">Mobile App Strategy &amp; Implementation for B2B and B2C Companies</h1>
    <app-hero-section height="520px" paddingTop="300px" opacity=".8"
        [backgroundImage]="`images/${file}/backgrounds/${file}.avif`" [title]="`images/${file}/${file}.svg`"
        text="service"></app-hero-section>

    <app-process></app-process>

    <!-- Social-proof bar -->
    <div class="w-full mt-[80px] mb-[40px] px-4 sm:px-[10%]">
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-[1050px] mx-auto">
            <div class="flex flex-col items-center bg-white/10 backdrop-blur-[40px] rounded-[24px] py-8 px-4 text-center">
                <div class="font-outfit text-4xl sm:text-5xl font-semibold gradient-text">15+</div>
                <div class="font-inter text-sm sm:text-base mt-2">apps shipped on iOS and Android</div>
            </div>
            <div class="flex flex-col items-center bg-white/10 backdrop-blur-[40px] rounded-[24px] py-8 px-4 text-center">
                <div class="font-outfit text-4xl sm:text-5xl font-semibold gradient-text">7</div>
                <div class="font-inter text-sm sm:text-base mt-2">industries served — healthcare, logistics, retail, B2B SaaS, and more</div>
            </div>
            <div class="flex flex-col items-center bg-white/10 backdrop-blur-[40px] rounded-[24px] py-8 px-4 text-center">
                <div class="font-outfit text-4xl sm:text-5xl font-semibold gradient-text text-center leading-tight">end-to-end</div>
                <div class="font-inter text-sm sm:text-base mt-2">strategy, design, build, launch, growth — one team</div>
            </div>
        </div>
    </div>

    <!-- Mid-page CTA -->
    <div class="w-full mt-[60px] mb-[80px] flex flex-col items-center px-4">
        <div class="font-inter text-sm sm:text-base text-center mb-[24px] max-w-[600px]">
            Want to talk through a specific use case for your business?
        </div>
        <app-button buttonText="schedule a call" (click)="scheduleCall('top')"></app-button>
    </div>

    <app-edge></app-edge>

    <div class="flex flex-col justify-content my-[80px] text-center">
        <div class="font-outfit font-semibold text-3xl text-center p-2">
           how we <span class="gradient-text">work with you</span>
        </div>
        <span class="font-inter text-sm sm:text-base px-4 sm:px-[15%]">Three phases. Defined deliverables. Realistic timelines from kickoff to launch.</span>
    </div>
    <app-consulting-process></app-consulting-process>

    <div class="mt-[100px]"></div>

    <app-info-card>
        <div class="flex flex-col justify-center items-center">
            <div class="font-outfit text-xl sm:text-3xl font-semibold mb-2 sm:mb-6">
                real results, <span class="gradient-text">real business impact</span>
            </div>
            <div class="font-inter mt-[17px] mb-6 sm:mb-[21px] text-center text-sm sm:text-base px-1 sm:px-[15%]">
                Our clients don't just get an app — they get a mobile strategy built to accelerate their business.
                We've helped B2B and B2C companies alike:
                <div
                    class="mt-[50px] px-2 font-outfit font-semibold text-base sm:text-lg grid grid-cols-1 [@media(min-width:1155px)]:grid-cols-2 gap-6">
                    <div class="flex flex-row items-start">
                        <img class="w-[26px] mr-[10px] mt-[6px]" src="images/shared/check.svg" alt="" loading="lazy">
                        <div class="text-left">
                            increase client retention with
                            personalized mobile experiences
                        </div>
                    </div>
                    <div class="flex flex-row items-start">
                        <img class="w-[26px] mr-[10px] mt-[6px]" src="images/shared/check.svg" alt="" loading="lazy">
                        <div class="text-left">
                            expand into new markets with
                            mobile-driven offerings
                        </div>
                    </div>
                    <div class="flex flex-row items-start">
                        <img class="w-[26px] mr-[10px] mt-[6px]" src="images/shared/check.svg" alt="" loading="lazy">
                        <div class="text-left">
                            reduce support costs through
                            self-service and automation
                        </div>
                    </div>
                    <div class="flex flex-row items-start">
                        <img class="w-[26px] mr-[10px] mt-[6px]" src="images/shared/check.svg" alt="" loading="lazy">
                        <div class="text-left">
                            improve operational visibility with
                            real-time data and analytics
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-info-card>

    <!-- FAQ -->
    <div class="w-full mt-[110px] mb-[40px] px-4 sm:px-[10%]">
        <div class="max-w-[1050px] mx-auto">
            <div class="font-outfit font-semibold text-3xl text-center mb-[50px]">
                common <span class="gradient-text">questions</span>
            </div>
            <div class="flex flex-col gap-4">
                <details class="bg-white/10 backdrop-blur-[40px] rounded-[24px] px-6 py-5 group">
                    <summary class="font-outfit font-semibold text-lg cursor-pointer list-none flex justify-between items-center">
                        <span>What does a typical engagement cost?</span>
                        <span class="ml-4 text-2xl gradient-text group-open:rotate-45 transition-transform">+</span>
                    </summary>
                    <div class="font-inter text-sm sm:text-base mt-4 leading-relaxed">
                        A discovery engagement runs $4k–$10k and produces a feature list, technical recommendation,
                        and budget. A full build is typically $20k–$200k depending on scope, integrations, and
                        platform coverage. We share a fixed quote after discovery — no surprises after.
                    </div>
                </details>
                <details class="bg-white/10 backdrop-blur-[40px] rounded-[24px] px-6 py-5 group">
                    <summary class="font-outfit font-semibold text-lg cursor-pointer list-none flex justify-between items-center">
                        <span>How long until we launch?</span>
                        <span class="ml-4 text-2xl gradient-text group-open:rotate-45 transition-transform">+</span>
                    </summary>
                    <div class="font-inter text-sm sm:text-base mt-4 leading-relaxed">
                        Discovery is 1–2 weeks. A focused first version is typically 8–16 weeks of build. So most
                        clients are in the App Store within 4 months of kickoff. Larger platforms ship a phase-one
                        first, then add scope iteratively.
                    </div>
                </details>
                <details class="bg-white/10 backdrop-blur-[40px] rounded-[24px] px-6 py-5 group">
                    <summary class="font-outfit font-semibold text-lg cursor-pointer list-none flex justify-between items-center">
                        <span>Do you only consult, or do you also build the app?</span>
                        <span class="ml-4 text-2xl gradient-text group-open:rotate-45 transition-transform">+</span>
                    </summary>
                    <div class="font-inter text-sm sm:text-base mt-4 leading-relaxed">
                        Both. The same team that scopes your strategy designs and ships the product. You don't
                        hand a roadmap to a separate dev shop and hope it survives translation. Strategy, design,
                        engineering, and growth are one team here.
                    </div>
                </details>
                <details class="bg-white/10 backdrop-blur-[40px] rounded-[24px] px-6 py-5 group">
                    <summary class="font-outfit font-semibold text-lg cursor-pointer list-none flex justify-between items-center">
                        <span>What tech stacks do you work with?</span>
                        <span class="ml-4 text-2xl gradient-text group-open:rotate-45 transition-transform">+</span>
                    </summary>
                    <div class="font-inter text-sm sm:text-base mt-4 leading-relaxed">
                        We ship native iOS and Android, and we use React Native, Flutter, and Angular/Ionic where
                        a hybrid codebase fits the budget and feature set. Backends are typically Node, Laravel,
                        or Python — chosen to fit your team's existing stack when there is one.
                    </div>
                </details>
                <details class="bg-white/10 backdrop-blur-[40px] rounded-[24px] px-6 py-5 group">
                    <summary class="font-outfit font-semibold text-lg cursor-pointer list-none flex justify-between items-center">
                        <span>We already have a partial app — can you pick it up?</span>
                        <span class="ml-4 text-2xl gradient-text group-open:rotate-45 transition-transform">+</span>
                    </summary>
                    <div class="font-inter text-sm sm:text-base mt-4 leading-relaxed">
                        Yes. Discovery includes a technical audit of what exists. We tell you honestly whether to
                        continue, refactor, or restart, and we scope the path forward against your budget.
                    </div>
                </details>
            </div>
        </div>
    </div>

    <div class="w-full mt-[80px] pb-[102px] flex flex-col items-center px-4">
        <div class="font-outfit font-semibold text-3xl text-center">
            <span class="gradient-text">let's talk</span> about your mobile path
        </div>
        <div class="mt-[31px] mb-[40px] px-4 sm:px-[12%] text-center text-sm sm:text-base max-w-[800px]">
            Schedule a 30-minute call. We'll talk through your idea and what a mobile path forward could look
            like — no sales script, no commitment.
        </div>
        <app-button buttonText="schedule a call" (click)="scheduleCall('bottom')"></app-button>
    </div>
</app-background>
